import * as React from 'react';
import { NewbuildingSeoBlock } from '../../components/NewbuildingSeoBlock';
import { useSelector } from 'react-redux';
import { getFromDevelopersPropsCount } from '../../selectors/newbuilding';
import { selectNewbuildingSeoBlock } from '../../selectors/newbuildingSeoBlock';
import { useApplicationContext } from '../../utils/applicationContext';

const NEWBUILDING_SEO_BLOCK_ENABLED_CONFIG = 'newbuilding-card-desktop-frontend.newbuildingSeoBlock.Enabled';

export const NewbuildingSeoBlockContainer = () => {
  const { config } = useApplicationContext();
  const seoBlock = useSelector(selectNewbuildingSeoBlock);
  const fromDevelopersPropsCount = useSelector(getFromDevelopersPropsCount);
  const isNewbuildingSeoBlockEnabled = config.get<boolean>(NEWBUILDING_SEO_BLOCK_ENABLED_CONFIG);

  if (!isNewbuildingSeoBlockEnabled || (!seoBlock.region && !seoBlock.city) || fromDevelopersPropsCount !== 0) {
    return null;
  }

  return <NewbuildingSeoBlock region={seoBlock.region} city={seoBlock.city} />;
};
